import React from 'react';
import Hero from './components/IQAC/practices/Hero';
import Main from './components/IQAC/practices/Main';

const IqacPractices = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacPractices;